import { Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import CardImage from "assets/icons/EventInfoImg.png";
import { ReactComponent as PlusIcon } from "assets/icons/plus.svg";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import MyModal from "components/MyModal";
import ReservationTabs from "components/reservationTabs/ReservationTabs";
import cuid from "cuid";
import { useFormik } from "formik";
import * as calculation from "helper/Calculate";
import { checkIsStripe, checkIsTranzila } from "helper/checkIsStripe";
import { useMobileView } from "hook/mobileView/useMobileView";
import { emailRegex } from "utils/validation";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setTicketsList } from "services/api/bulkClass";
import {
  transformVariantInfoToArray,
  transformVariantInfoToObject,
} from "utils/variantInfo";
import ViewClassInfoModal from "../ClassInfo/ViewClassInfoModal";
import Header from "./Header/Header";
import DonationBox from "components/DonationBox/DonationBox";
import FinanceService from "Lib/API/Finance";
import { PersonalDetailsCard } from "./PersonalDetailsCard/PersonalDetailsCard";
import SummaryCard from "./SummaryCard/SummaryCard";

import { ContactUs } from "components/ContactUs/ContactUs";
import { postalCodeFormat, postalCodeLabel } from "helper/postalCodeFormat";
import AuthService from "Lib/API/Auth";
import MemberService from "Lib/API/Member";
import { useSnackbar } from "notistack";
import { toastr } from "react-redux-toastr";
import { ClipLoader } from "react-spinners";
import { groupProducts } from "utils/groupProducts";
import { bulkAnswerRequiredFields } from "./bulkAnswerRequiredFields";
import { PaymentCard } from "./PaymentCard/PaymentCard";
import { PaymentResultPage } from "./PaymentResultPage/PaymentResultPage";
import { defaultRequiredFields } from "./requiredFields";
import {
  CardContent,
  ImageCard,
  ImageContainer,
  PaymentButtonSubmit,
  ReservationHeader,
  Wrapper,
} from "./Theme";
import BulkTicket from "./Tickets/BulkTicket";
import Ticket from "./Tickets/Ticket";
import {
  getAccessTokenSilently,
  getAuthenticated,
  logout,
} from "utils/functions";
import { useHistory } from "react-router-dom";
import { convenienceFeeAmount as calcConvenienceFee } from "helper/convenienceFee";

const ReservationBulkSchoolPage = () => {
  const allowInstallmentsOrganization =
    localStorage.getItem("allowInstallments") === "true";
  const { push } = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams();

  const isAuthenticated = getAuthenticated();
  const { logoImage } = useSelector((state) => state.organization);
  const { bulkClassDetails, ticketsList } = useSelector(
    (state) => state?.bulkClass,
  );
  const [error, setError] = useState({ value: true, message: "" });

  const { isMobile } = useMobileView();
  const postalLabel = postalCodeLabel();
  const token = localStorage.getItem("token");
  const formData = new FormData();

  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;

  const logo = isAuth ? logoImage : localStorage.getItem("logoImgSchool");

  const addCardStripeRef = useRef(null);
  const recaptchaRef = useRef();
  const paymentMethod = JSON.parse(localStorage.getItem("paymentMethodSchool"));
  const achPaymentMethod = JSON.parse(
    localStorage.getItem("achPaymentMethodSchool"),
  );

  const [applyToAllTickets, setApplyToAllTickets] = useState(false);
  const [applySelectedFamilyMember, setApplySelectedFamilyMember] = useState(
    false,
  );
  const [ticketTypeTabs, setTicketTypeTabs] = useState([]);
  const [activeTicket, setActiveTicket] = useState(0);
  const [isLoadingPay, setLoadingPay] = useState(false);
  const [calcPriceFailed, setCalcPriceFailed] = useState(false);
  const [calcDueAmount, setCalcDueAmount] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [checkoutDonationLedger, setCheckoutDonationLedger] = useState(null);
  const [donationAmount, setDonationAmount] = useState(0);
  const [isLoadingDonationLedger, setIsLoadingDonationLedger] = useState(true);
  const [selectedAchCard, setSelectedAchCard] = useState(null);
  const [isFamilyMemberLoading, setIsFamilyMemberLoading] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [familyMemberPage, setFamilyMemberPage] = useState(1);
  const [familyMemberSearch, setFamilyMemberSearch] = useState("");
  const [hasMoreFamilyMembers, setHasMoreFamilyMembers] = useState(true);
  const [familyMembersInitialized, setFamilyMembersInitialized] = useState(
    false,
  );
  const [applyAccountDetails, setApplyAccountDetails] = useState(false);

  const [confirmDeleteTicket, setConfirmDeleteTicket] = useState({
    open: false,
    ticketId: null,
    ticketIndex: null,
    isLoading: false,
  });
  const [classInfoModal, setClassInfoModal] = useState({
    open: false,
    classDetails: {},
    ticketId: null,
  });
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedClassesList, setSelectedClassesList] = useState([]);
  const [convenienceFeeByPayment, setConvenienceFeeByPayment] = useState({
    "credit-card": true,
    ach: true,
  });

  const enableCreditCardPay = paymentMethod?.allow_member || !isAuth;
  const enableAchPay =
    achPaymentMethod?.allow_member && checkIsStripe(achPaymentMethod);

  const isInstallmentEnabled = useMemo(() => {
    if (!allowInstallmentsOrganization) {
      return false;
    }

    return isAuth
      ? paymentMethod?.allowMemberInstallment ||
      achPaymentMethod?.allowMemberInstallment
      : true;
  }, [allowInstallmentsOrganization, isAuth, paymentMethod, achPaymentMethod]);

  const initialActivePayment = useMemo(() => {
    if (isAuth) {
      if (enableCreditCardPay) return "credit-card";
      if (enableAchPay) return "ach";
      return "credit-card";
    }
    return "credit-card";
  }, [isAuth, enableCreditCardPay, enableAchPay]);

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: false,
    initialValues: {
      bulkRegistrationForm: [],
      bulkRegistrationFormErrors: [],
      registrationForm: [],
      errors: [],
      ticketsData: Array.from({ length: ticketsList?.length }, () => []),
      dropdowns: [],
      accountInfo: {},
      cardsDetails: {},
      resultPage: "",
      activePayment: initialActivePayment,
    },
    validationSchema: false,
    onSubmit: async (values) => { },
  });

  const activePayment = formik?.values?.activePayment;
  const formDataReservation = formik?.values?.registrationForm || [];
  const formDataErrors = formik?.values?.errors || [];
  const bulkRegistrationForm = formik?.values?.bulkRegistrationForm || [];

  const getAllProducts = useCallback(() => {
    const allProducts = formDataReservation?.reduce((acc, item) => {
      const products = item?.products || [];
      return [...acc, ...products];
    }, []);

    return groupProducts(allProducts);
  }, [formDataReservation]);

  const getAllOnRegistrationTickets = useCallback(() => {
    return selectedClassesList?.reduce((acc, item) => {
      const prices = item?.class_pricing?.prices || [];
      const registrationPrices = prices.filter(
        (price) => price?.type === "onRegistration",
      );
      return [...acc, ...registrationPrices];
    }, []);
  }, [selectedClassesList]);

  const getRequiredFields = useCallback(
    (classInfo) => {
      const currentClass = selectedClassesList.find(
        (item) => item?.ticketId === classInfo?.id,
      );
      if (!currentClass) return [];
      return (
        currentClass?.form?.task_data?.filter(
          (item) => item?.required === true,
        ) || []
      );
    },
    [selectedClassesList],
  );

  // Family member API functions
  const fetchFamilyMembers = useCallback(
    async (page = 1, search = "", resetData = false) => {
      if (isFamilyMemberLoading) return;

      setIsFamilyMemberLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const response = await AuthService.getFamilyMember(
          page,
          10,
          token,
          search,
        );
        const newMembers = response?.contacts || [];

        if (page === 1 || resetData) {
          setFamilyMembers(newMembers);
        } else {
          setFamilyMembers((prev) => [...prev, ...newMembers]);
        }

        setHasMoreFamilyMembers(newMembers.length === 10);
        setFamilyMembersInitialized(true);
      } catch (error) {
        toastr.error(error?.data?.message || "Something went wrong!");
      } finally {
        setIsFamilyMemberLoading(false);
      }
    },
    [getAccessTokenSilently, isFamilyMemberLoading],
  );

  const handleFamilyMemberSearch = useCallback(
    (search) => {
      if (search !== familyMemberSearch) {
        setFamilyMemberSearch(search);
        setFamilyMemberPage(1);
        fetchFamilyMembers(1, search, true);
      }
    },
    [familyMemberSearch, fetchFamilyMembers],
  );

  const handleFamilyMemberScroll = useCallback(() => {
    if (isFamilyMemberLoading || !hasMoreFamilyMembers) return;
    const nextPage = familyMemberPage + 1;
    setFamilyMemberPage(nextPage);
    fetchFamilyMembers(nextPage, familyMemberSearch);
  }, [
    isFamilyMemberLoading,
    hasMoreFamilyMembers,
    familyMemberPage,
    familyMemberSearch,
    fetchFamilyMembers,
  ]);

  // Initialize family members only once
  useEffect(() => {
    const fetchCheckoutDonationLedger = async () => {
      try {
        const orgToken = isAuth
          ? await getAccessTokenSilently()
          : localStorage.getItem("schoolToken");
        const orgId = localStorage.getItem("schoolOrgId");
        const res = await FinanceService.getCheckoutDonationLedger(orgToken, orgId);
        if (res?.ledger) setCheckoutDonationLedger(res.ledger);
      } catch (_) {} finally {
        setIsLoadingDonationLedger(false);
      }
    };
    fetchCheckoutDonationLedger();
  }, []);

  useEffect(() => {
    if (isAuth && !familyMembersInitialized && !isFamilyMemberLoading) {
      fetchFamilyMembers(1, "", true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, familyMembersInitialized]);
  const hasInstallmentOption = useCallback(() => {
    const allProducts = getAllProducts();
    const allTickets = getAllOnRegistrationTickets();

    const hasInstallmentInProducts = allProducts.some(
      (product) => product?.installmentStatus,
    );
    const hasInstallmentInTickets = allTickets.some(
      (ticket) => ticket?.installmentStatus,
    );

    return hasInstallmentInProducts || hasInstallmentInTickets;
  }, []);
  const hasInstallment = hasInstallmentOption();
  const disabledCreditCardPay =
    hasInstallment && !paymentMethod?.allowMemberInstallment && isAuth;
  const disabledAchPay =
    (hasInstallment && !achPaymentMethod?.allowMemberInstallment) ||
    (enableAchPay && !isAuth);
  const displayAchTooltip = useMemo(
    () => (enableAchPay && !isAuth ? "Please login to pay with ACH" : ""),
    [enableAchPay, isAuth],
  );

  useEffect(() => {
    localStorage.removeItem("redirectUrl");
  }, []);
  useEffect(() => {
    let keysWithoutData = [];
    if (formDataReservation?.length === 0) {
      ticketsList.map((item) => {
        keysWithoutData.push({
          id: item.id,
          formData: [],
          products: [],
          selectedMember: null,
        });
      });
      formik.setFieldValue("registrationForm", keysWithoutData);
    }
  }, [isAuth, ticketsList, formDataReservation, formik]);

  useEffect(() => {
    const accountDetails = JSON.parse(localStorage.getItem("accountInfo"));
    if (isAuth && accountDetails) {
      setTimeout(() => {
        const accountDetails = JSON.parse(localStorage.getItem("accountInfo"));
        formik.setFieldValue("accountInfo", {
          first_name: accountDetails?.firstName ?? "",
          last_name: accountDetails?.lastName ?? "",
          primary_email_address: accountDetails?.primary_email_address ?? "",
        });
      }, 2000);
      const updatedBulkRegistrationForm = bulkAnswerRequiredFields.map(
        (field) => {
          if (field.id === "7306E1AD-745F-4BEE-829C-71BB380ED61B") {
            return {
              ...field,
              value: accountDetails?.firstName || "",
            };
          }
          if (field.id === "99267192-0200-403C-813D-8AF374FE25D0") {
            return {
              ...field,
              value: accountDetails?.lastName || "",
            };
          }
          if (field.id === "986AB1B0-19F0-4339-8594-59427982B41D") {
            return {
              ...field,
              value: accountDetails?.primary_email_address || "",
            };
          }
          if (field.id === "3A514A2D-58A7-4D33-9BA7-44551E571FD5") {
            return {
              ...field,
              value: accountDetails?.emergency_contact_name || "",
            };
          }
          if (field.id === "F027F052-CDF8-43E8-ADD5-5425F3BCFBAD") {
            return {
              ...field,
              value: accountDetails?.emergency_contact_number || "",
            };
          }
          return field;
        },
      );
      formik.setFieldValue("bulkRegistrationForm", updatedBulkRegistrationForm);
      setApplyAccountDetails(true);
    }
  }, [isAuth, localStorage.getItem("accountInfo")]);

  useEffect(() => {
    if (!ticketsList?.length || ticketTypeTabs?.length) return;
    const updatedTicketTypeTabs = ticketsList?.map((item) => {
      return {
        ...item,
        valid: false,
      };
    });
    setTicketTypeTabs(updatedTicketTypeTabs);
  }, [ticketsList]);

  const onDeleteTicket = (tab, index) => {
    setConfirmDeleteTicket({
      open: true,
      ticketId: tab?.id,
      ticketIndex: index,
      isLoading: false,
    });
  };
  const closeConfirmDeleteTicket = () => {
    setConfirmDeleteTicket({
      open: false,
      ticketId: null,
      ticketIndex: null,
      isLoading: false,
    });
  };

  const handleLogout = () => {
    formik.setFieldValue("accountInfo", {});
    formik.setFieldValue("activePayment", "credit-card");
    localStorage.clear();
    window.location.href = `/school/bulk/${params?.id}`;
  };

  const handleDeleteTicket = async () => {
    const ticketId = confirmDeleteTicket?.ticketId;
    const newTicketTypeList = [...ticketTypeTabs];
    const ticketTypeIndex = newTicketTypeList.findIndex(
      (ticket) => ticket.id === ticketId,
    );
    newTicketTypeList.splice(ticketTypeIndex, 1);
    setTicketTypeTabs(newTicketTypeList);
    dispatch(setTicketsList(newTicketTypeList));
    const updateSelectedClassesList = selectedClassesList.filter(
      (item) => item?.ticketId !== ticketId,
    );
    setSelectedClassesList(updateSelectedClassesList);
    setActiveTicket(0);
    // Remove the ticket from formDataReservation
    const updatedFormDataReservation = formDataReservation.filter(
      (item) => item?.id !== ticketId,
    );
    formik.setFieldValue("registrationForm", updatedFormDataReservation);
    closeConfirmDeleteTicket();
  };

  const handleAddNewClassTicket = () => {
    const newTicketTypeList = [...ticketTypeTabs];
    const ticketId = cuid();
    newTicketTypeList.push({
      id: ticketId,
      name: "Enrollment",
    });
    setTicketTypeTabs(newTicketTypeList);
    dispatch(setTicketsList(newTicketTypeList));
    formik.setFieldValue("registrationForm", [
      ...formik.values.registrationForm,
      {
        id: ticketId,
        formData: [],
        products: [],
        selectedMember: null,
      },
    ]);
  };

  const updateBulkFormDataHandler = useCallback((form) => {
    formik.setFieldValue("bulkRegistrationForm", form);
  }, []);

  const updatedFormDataHandler = useCallback(
    (form, ticketId, currentFormData, member = null) => {
      const updatedFormDataReservation = [...formDataReservation];
      const existingEntryIndex = updatedFormDataReservation.findIndex(
        (item) => item.id === ticketId,
      );
      if (existingEntryIndex !== -1) {
        updatedFormDataReservation[existingEntryIndex] = {
          ...updatedFormDataReservation[existingEntryIndex],
          formData: form,
          selectedMember:
            member ||
            updatedFormDataReservation[existingEntryIndex].selectedMember,
        };
        formik.setFieldValue("registrationForm", updatedFormDataReservation);
        checkFormDataValidation(
          updatedFormDataReservation,
          ticketId,
          currentFormData,
        );
      }
    },
    [formDataReservation, formik, checkFormDataValidation],
  );

  const removeFamilyMember = useCallback(
    (ticketId) => {
      const updatedFormDataReservation = [...formDataReservation];
      const existingEntryIndex = updatedFormDataReservation.findIndex(
        (item) => item.id === ticketId,
      );
      if (existingEntryIndex !== -1) {
        updatedFormDataReservation[existingEntryIndex] = {
          ...updatedFormDataReservation[existingEntryIndex],
          selectedMember: null,
        };
        formik.setFieldValue("registrationForm", updatedFormDataReservation);
        checkFormDataValidation(
          updatedFormDataReservation,
          ticketId,
          updatedFormDataReservation[existingEntryIndex]?.formData,
        );
      }
    },
    [formDataReservation, formik, checkFormDataValidation],
  );

  const checkFormDataValidation = useCallback(
    (formData, ticketId, currentFormData) => {
      const ticketData = formData?.find((item) => item.id === ticketId);
      if (ticketData?.formData?.length === 0) return;
      const allFormFields = currentFormData?.length
        ? currentFormData
        : defaultRequiredFields || [];
      const requiredFields = allFormFields?.filter(
        (item) => item.required === true,
      );
      const isFormValid = requiredFields?.every((item) => {
        const formField = ticketData?.formData?.find(
          (field) => field.id === item.id,
        );
        return (
          formField?.value &&
          formField?.value !== null &&
          formField?.value !== undefined
        );
      });
      const currentTab = ticketTypeTabs?.findIndex(
        (item) => item.id === ticketId,
      );
      const updatedTicketTypeTabs = ticketTypeTabs?.map((item, index) => {
        if (index === currentTab) {
          return { ...item, valid: isFormValid };
        }
        return item;
      });
      setTicketTypeTabs(updatedTicketTypeTabs);
    },
    [ticketTypeTabs],
  );

  const isValidInstallment = () => {
    const allProducts = getAllProducts();
    const allTickets = getAllOnRegistrationTickets();
    const isValidProducts = allProducts.every((product) => {
      if (product?.installmentStatus && !product?.installment?.value) {
        return false;
      }
      return true;
    });
    const isValidTickets = allTickets.every((ticket) => {
      if (ticket?.installmentStatus && !ticket?.installment?.value) {
        return false;
      }
      return true;
    });
    return isValidProducts && isValidTickets;
  };

  const handleGetStripeToken = async () => {
    const tokenId = await addCardStripeRef?.current?.handleGetToken();
    if (tokenId && tokenId !== null && token !== undefined) {
      return tokenId;
    }
    return "";
  };

  const updatedProductsData = (products) => {
    return products
      .map((product) => {
        const hasInstallment = product?.installmentStatus;
        if (product?.totalCount === 0) return null;
        return {
          id: product?._id,
          title: product?.title,
          ...(product?.variant
            ? {
              variant:
                transformVariantInfoToObject(product?.variantInfo) || {},
            }
            : {
              quantity: product?.totalCount,
            }),

          ...(hasInstallment
            ? { numberOfInstallments: product?.installment?.value }
            : {}),
        };
      })
      .filter((item) => item !== null);
  };

  const installmentOnRegistrationPrices = () => {
    const allTickets = getAllOnRegistrationTickets();
    const installmentPrices = allTickets
      ?.map((item) => {
        if (item?.installmentStatus) {
          return {
            priceId: item?._id,
            numberOfInstallment: item?.installment?.value,
          };
        }
      })
      .filter((item) => item !== undefined);
    return installmentPrices;
  };

  const handleDataForTwoFlow = (tokenId = "", coverFee = true, tranzilaChargeResult = null) => {
    formData.append(`isMember`, isAuth ? true : false);
    if (!isAuth) {
      formData.append(`orgId`, localStorage.getItem("schoolOrgId"));
    }
    formData.append(`bulkClassId`, params?.id);
    formData.append("coverFee", coverFee);

    const objectName = "cardsDetails";
    const objectData = formik?.values?.cardsDetails;
    if (formik?.values?.activePayment === "credit-card") {
      formData.append("paymentMethodId", paymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedCard);
      } else if (tranzilaChargeResult) {
        formData.append("tranzilaChargeResult", JSON.stringify(tranzilaChargeResult));
      } else if (tokenId) {
        formData.append("token", tokenId);
      } else {
        for (const key in objectData) {
          if (key === "expiry") {
            formData.append(
              `${objectName}[exp_month]`,
              objectData[key]?.split("/")[0],
            );
            formData.append(
              `${objectName}[exp_year]`,
              objectData[key]?.split("/")[1],
            );
          } else if (key === "card_number") {
            formData.append(`${objectName}[number]`, objectData[key]);
          } else {
            formData.append(`${objectName}[${key}]`, objectData[key]);
          }
        }
      }
    } else if (formik?.values?.activePayment === "ach") {
      formData.append("paymentMethodId", achPaymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedAchCard);
      }
    }

    // Checkout donation
    if (donationAmount > 0 && checkoutDonationLedger) {
      formData.append("checkoutDonation[ledger_id]", checkoutDonationLedger._id || checkoutDonationLedger.ledger_id || "");
      formData.append("checkoutDonation[ledger_name]", checkoutDonationLedger.ledger_name || "");
      formData.append("checkoutDonation[amount]", donationAmount);
      if (checkoutDonationLedger.account_receivable) {
        formData.append("checkoutDonation[account_receivable]", checkoutDonationLedger.account_receivable);
      }
    }
    if (isAuth) return;
    // Account Info
    const objectName2 = "accountInfo";
    const objectData2 = formik?.values?.accountInfo;
    for (const key in objectData2) {
      if (key === "addresses") {
        const objeLocation = formik.values?.accountInfo?.addresses[0].location;
        if (Object.keys(objeLocation).length !== 0) {
          formik.values?.accountInfo?.addresses[0].location?.formattedAddress &&
            formData.append(
              `${objectName2}[addresses][0][location][formattedAddress]`,
              formik.values?.accountInfo?.addresses[0].location
                ?.formattedAddress,
            );
          formik.values?.accountInfo?.addresses[0].location?.place_id &&
            formData.append(
              `${objectName2}[addresses][0][location][place_id]`,
              formik.values?.accountInfo?.addresses[0].location?.place_id,
            );
          formik.values?.accountInfo?.addresses[0]?.city &&
            formData.append(
              `${objectName2}[addresses][0][city]`,
              formik.values?.accountInfo?.addresses[0]?.city,
            );
          formik.values?.accountInfo?.addresses[0]?.state &&
            formData.append(
              `${objectName2}[addresses][0][state]`,
              formik.values?.accountInfo?.addresses[0]?.state,
            );
          formik.values?.accountInfo?.addresses[0]?.zip_code &&
            formData.append(
              `${objectName2}[addresses][0][zip_code]`,
              formik.values?.accountInfo?.addresses[0]?.zip_code,
            );
          formik.values?.accountInfo?.addresses[0]?.addressLine2 &&
            formData.append(
              `${objectName2}[addresses][0][addressLine2]`,
              formik.values?.accountInfo?.addresses[0]?.addressLine2,
            );
        }
      } else {
        formData.append(`${objectName2}[${key}]`, objectData2[key]);
      }
    }
  };

  const handleSendTicketProductsForm = () => {
    const installmentPrices = installmentOnRegistrationPrices();

    formData.append(`parentInfo`, JSON.stringify([...bulkRegistrationForm]));

    if (installmentPrices?.length > 0) {
      formData.append(`installments`, JSON.stringify([...installmentPrices]));
    }

    const dataArray = [...formDataReservation];
    if (dataArray[0] !== undefined) {
      const formDataArray = dataArray.map((dataItem, dataIndex) => {
        const { id, formData: formDataItem, products } = dataItem;
        const updatedProducts = updatedProductsData(products);
        const classId =
          selectedClassesList?.find((item) => item?.ticketId === id)?._id ||
          null;

        formData.append(`registrationForm[${dataIndex}][id]`, `${id}`);
        formData.append(
          `registrationForm[${dataIndex}][classId]`,
          `${classId}`,
        );

        formData.append(
          `registrationForm[${dataIndex}][formData]`,
          JSON.stringify([...formDataItem]),
        );

        formData.append(
          `registrationForm[${dataIndex}][products]`,
          JSON.stringify([...updatedProducts]),
        );
        const formDataObj = formDataItem?.forEach((dataItem) => {
          if (dataItem?.name?.includes("file_upload")) {
            if (dataItem?.value && dataItem?.value !== null) {
              formData.append(
                `registrationForm[${dataIndex}][files][${id}]`,
                dataItem?.value,
              );
            }
          }
        });
      });
    }
  };

  const checkValidateBulkRegistrationForm = () => {
    const bulkRequiredFields = bulkClassDetails?.form?.task_data?.filter(
      (field) => field.required,
    );
    const bulkRegistrationFormErrors = bulkRegistrationForm?.map((item) => {
      const requiredField = bulkRequiredFields?.find(
        (field) => field.id === item.id,
      );
      if (requiredField) {
        if (item.value && item.name.includes("email_input")) {
          return {
            id: item.id,
            errorMsg: emailRegex.test(item.value)
              ? ""
              : `Please enter valid email for (${requiredField.label}) field`,
          };
        }
        if (item.value && item.name.includes("phone_input")) {
          const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
          return {
            id: item.id,
            errorMsg: phoneRegex.test(item.value)
              ? ""
              : `Please enter valid Phone Number for (${requiredField.label}) field`,
          };
        }
        if (!item.value || item.value === "") {
          return {
            id: item.id,
            errorMsg: `The ${requiredField.label} is required`,
          };
        }
      }
      return { id: item.id, errorMsg: "" };
    });
    formik.setFieldValue(
      "bulkRegistrationFormErrors",
      bulkRegistrationFormErrors?.filter((item) => item.errorMsg !== ""),
    );
    const hasErrors = bulkRegistrationFormErrors?.some(
      (item) => item.errorMsg !== "",
    );
    return !hasErrors;
  };

  const handleTranzilaCharged = async (result) => {
    handleDataForTwoFlow("", true, result);
    handleSendTicketProductsForm();
    setLoadingPay(true);
    try {
      const token = localStorage.getItem("schoolToken");
      await MemberService.createBulkParticipant(token, formData);
      formik.setFieldValue("resultPage", "success");
    } catch (err) {
      enqueueSnackbar(err?.data?.message || "Payment failed, please try again", { variant: "error" });
    } finally {
      setLoadingPay(false);
    }
  };

  const payNow = async (hasStripe) => {
    if (
      (totalDueAmount > 0 ? !formik?.values?.activePayment : false) ||
      isLoadingPay
    )
      return;
    const hasAllClassesSelected =
      selectedClassesList.length === formDataReservation.length;
    if (!hasAllClassesSelected)
      return enqueueSnackbar("Please select class for all enrollments", {
        variant: "info",
      });

    const isDisable = ticketTypeTabs?.some((item) => !item.valid);
    if (isDisable)
      return enqueueSnackbar(
        "Please fill all required fields for all enrollments",
        {
          variant: "info",
        },
      );

    const captchaValue = recaptchaRef?.current?.getValue();
    if (!captchaValue && !isAuth && totalDueAmount > 0)
      return enqueueSnackbar("Please verify the captcha", {
        variant: "info",
      });

    const thereIsFormEmpty = formDataReservation?.some(
      (item) => item?.formData?.length === 0,
    );
    if (thereIsFormEmpty)
      return enqueueSnackbar(
        "You have errors in filling out the form , please check them",
        {
          variant: "error",
        },
      );

    const dataValidation = formDataReservation?.map((item, index) => {
      const requiredFields = getRequiredFields(item);
      return {
        ...item,
        formData: item?.formData
          ?.map((subItem, subItemIndex) => {
            const requireds = requiredFields?.find(
              (tofinditem) =>
                tofinditem.id === subItem.id && tofinditem.required,
            );
            if (
              subItem?.name.includes("file_upload") &&
              requireds !== undefined
            ) {
              if (!subItem.value?.name || subItem.value?.name === undefined) {
                return { errorMessage: `The ${requireds?.label} is required` };
              } else {
                return { errorMessage: "" };
              }
            }
            if (subItem.value && subItem?.value?.length > 0) {
              if (subItem?.name.includes("email_input")) {
                return {
                  errorMessage: emailRegex.test(subItem.value)
                    ? ""
                    : `Please enter valid email for (${requiredFields[subItemIndex]?.label}) field`,
                };
              }
              if (subItem?.name.includes("phone_input")) {
                const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                return {
                  errorMessage: phoneRegex.test(subItem.value)
                    ? ""
                    : `Please enter valid Phone Number for (${requiredFields[subItemIndex]?.label}) field`,
                };
              } else {
                return { errorMessage: "" };
              }
            }
            if (requireds !== undefined) {
              return { errorMessage: `The ${requireds.label} is required` };
            } else {
              return { errorMessage: "" };
            }
          })
          .filter((element) => element.errorMessage !== ""),
      };
    });
    formik.setFieldValue("errors", dataValidation);

    const validBulkRegistrationForm = checkValidateBulkRegistrationForm();
    if (!validBulkRegistrationForm) {
      return enqueueSnackbar(
        "Please fill all required fields in the bulk registration form",
        {
          variant: "error",
        },
      );
    }

    const allErrorsEmpty = dataValidation.every(
      (item) => item.formData.length === 0,
    );
    if (allErrorsEmpty) {
      const validInstallment = isValidInstallment();
      if (!validInstallment) {
        return enqueueSnackbar("Please select number of installments", {
          variant: "info",
        });
      }

      const validZipCode = postalCodeFormat(formik?.values?.cardsDetails?.zip);
      if (
        !isStripe &&
        formik?.values?.cardsDetails?.zip?.length &&
        !validZipCode &&
        formik?.values?.activePayment === "credit-card" &&
        !isAuth
      ) {
        enqueueSnackbar(`Invalid ${postalLabel}`, { variant: "info" });
      }

      let tokenId = "";
      if (
        isStripe &&
        formik?.values?.activePayment === "credit-card" &&
        !isAuth
      ) {
        tokenId = await handleGetStripeToken();
      }

      if (
        isAuth &&
        !selectedCard &&
        formik?.values?.activePayment === "credit-card" &&
        totalDueAmount > 0
      ) {
        enqueueSnackbar("Please select a credit card", { variant: "error" });
        return;
      }

      if (
        isAuth &&
        !selectedAchCard &&
        formik?.values?.activePayment === "ach" &&
        totalDueAmount > 0
      ) {
        enqueueSnackbar("Please select an ACH card", { variant: "error" });
        return;
      }

      if (
        (hasStripe && tokenId) ||
        !hasStripe ||
        formik?.values?.activePayment === "bill-my-account" ||
        (isAuth && selectedCard) ||
        (isAuth && selectedAchCard)
      ) {
        handleDataForTwoFlow(
          tokenId || "",
          convenienceFeeByPayment[activePayment],
        );
        handleSendTicketProductsForm();
        if (error?.message) {
          enqueueSnackbar(error?.message, {
            variant: "error",
          });
          setLoadingPay(false);
        } else {
          setLoadingPay(true);
          const token = isAuth
            ? await getAccessTokenSilently()
            : localStorage.getItem("schoolToken");
          try {
            await MemberService.createBulkParticipant(token, formData).then(
              (res) => {
                formik.setFieldValue("resultPage", "success");
              },
            );
          } catch (error) {
            const message = error?.data?.message
              ? error?.data?.message
              : "Something went wrong";
            enqueueSnackbar(message, {
              variant: "error",
            });
          } finally {
            setLoadingPay(false);
          }
        }
      } else {
        enqueueSnackbar(
          "You have errors in filling out the form , please check them",
          {
            variant: "error",
          },
        );
      }
    }
  };

  const displayTicketName = (ticket, index) => {
    if (!ticket) return ` #${index + 1}`;
    return `${ticket?.name?.toLowerCase() === "ticket" ? "" : ticket?.name
      } #${index + 1}`;
  };

  const setActivePaymentAfter = useCallback(() => {
    if (!isAuth) return formik.setFieldValue("activePayment", "credit-card");
    const activePayment = formik.values?.activePayment;
    if (
      paymentMethod?.allowMemberInstallment &&
      achPaymentMethod?.allowMemberInstallment
    ) {
      return;
    }

    const nextPayment = paymentMethod?.allowMemberInstallment
      ? "credit-card"
      : achPaymentMethod?.allowMemberInstallment
        ? "ach"
        : null;

    if (nextPayment) {
      formik.setFieldValue("activePayment", nextPayment);
    }
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const openClassInfoModal = (classDetails, ticketId) => {
    setClassInfoModal({
      open: true,
      classDetails: classDetails,
      ticketId: ticketId,
    });
  };

  const closeClassInfoModal = () => {
    setClassInfoModal({
      open: false,
      classDetails: {},
      ticketId: null,
    });
    setSelectedClass(null);
  };

  const onSelectClass = ({ ticketId = null, classDetails = null }) => {
    const updatedSelectedClassesList = [...selectedClassesList];
    const currentTicketId = ticketId || classInfoModal?.ticketId;
    const currentClassDetails = classDetails || classInfoModal?.classDetails;
    if (currentTicketId && currentClassDetails) {
      const classIndex = updatedSelectedClassesList.findIndex(
        (item) => item?.ticketId === currentTicketId,
      );
      if (classIndex !== -1) {
        updatedSelectedClassesList[classIndex] = {
          ...updatedSelectedClassesList[classIndex],
          ...currentClassDetails,
        };
      } else {
        updatedSelectedClassesList.push({
          ...currentClassDetails,
          ticketId: currentTicketId,
        });
      }
      setSelectedClassesList(updatedSelectedClassesList);
      setSelectedClass(null);
      closeClassInfoModal();

      let productsData = [];
      if (currentClassDetails?.class_pricing?.prices?.length > 0) {
        const optionalProducts = currentClassDetails?.class_pricing?.prices?.filter(
          (item) => item?.type === "optional",
        );
        if (optionalProducts?.length > 0) {
          const products = optionalProducts.map((item) => ({
            ...item,
            variantInfo: transformVariantInfoToArray(item?.variantInfo || {}),
            counter: 0,
            selectedVariants: [],
            totalCount: 0,
            totalAmount: 0,
          }));
          productsData = [...productsData, ...products];
        }
      }

      const updatedFormDataReservation = [...formDataReservation];
      const existingEntryIndex = updatedFormDataReservation.findIndex(
        (item) => item.id === currentTicketId,
      );
      if (existingEntryIndex !== -1) {
        updatedFormDataReservation[existingEntryIndex] = {
          ...updatedFormDataReservation[existingEntryIndex],
          products: productsData,
        };
        formik.setFieldValue("registrationForm", updatedFormDataReservation);
      }
    }
  };

  const removeSelectedClass = useCallback(
    (ticketId) => {
      const updatedSelectedClassesList = selectedClassesList.filter(
        (item) => item?.ticketId !== ticketId,
      );
      setSelectedClassesList(updatedSelectedClassesList);
      const copyFormDataReservation = [...formDataReservation];
      const updatedFormDataReservation = copyFormDataReservation.map((item) => {
        if (item?.id === ticketId) {
          return {
            ...item,
            formData: [],
            products: [],
            selectedMember: null,
          };
        }
        return item;
      });
      formik.setFieldValue("registrationForm", updatedFormDataReservation);
    },
    [selectedClassesList, formDataReservation, formik],
  );

  const classesList = useMemo(() => bulkClassDetails?.classes, [
    bulkClassDetails?.classes,
  ]);

  const getCurrentClass = useCallback(
    (ticketId) => {
      if (!selectedClassesList?.length) return null;
      return selectedClassesList.find((item) => item?.ticketId === ticketId);
    },
    [selectedClassesList],
  );

  const getCurrentFormTaskData = useCallback(() => {
    if (!selectedClassesList?.length) return [];
    const currentTicket = ticketTypeTabs[activeTicket];
    const currentClass = selectedClassesList.find(
      (item) => item?.ticketId === currentTicket?.id,
    );
    return currentClass?.form?.task_data || [];
  }, [selectedClassesList, ticketTypeTabs, activeTicket]);

  const getCurrentFormTicketErrors = useCallback(() => {
    if (!formDataErrors?.length) return [];
    const currentTicket = ticketTypeTabs[activeTicket];
    const currentErrors = formDataErrors.find(
      (item) => item.id === currentTicket?.id,
    );
    return currentErrors?.formData || [];
  }, [formDataErrors, ticketTypeTabs, activeTicket]);

  const onUpdatedClassDetails = useCallback(
    (updatedClassDetails) => {
      setSelectedClassesList((prev) => {
        return prev.map((item) => {
          if (
            item?._id === updatedClassDetails?._id &&
            item?.ticketId === updatedClassDetails?.ticketId
          ) {
            return {
              ...item,
              ...updatedClassDetails,
            };
          }
          return item;
        });
      });
    },
    [dispatch, setSelectedClassesList],
  );

  const updatedProducts = useCallback(
    ({ productId, installmentStatus, installment }) => {
      const formDataReservationCopy = [...formDataReservation];
      const updatedFormDataReservation = formDataReservationCopy.map((item) => {
        const updatedProducts = item?.products?.map((product) => {
          if (product?._id === productId) {
            return {
              ...product,
              installmentStatus: installmentStatus,
              installment: installment,
            };
          }
          return product;
        });
        return {
          ...item,
          products: updatedProducts,
        };
      });
      formik.setFieldValue("registrationForm", updatedFormDataReservation);
    },
    [formDataReservation, formik],
  );

  // const totalAmountCalculation = calculation?.calculateBulkClassesDiscount(selectedClassesList, isAuth);
  // const totalDiscount = totalAmountCalculation?.totalDiscount

  const getCurrentPaymentMethod = useCallback(() => {
    if (formik?.values?.activePayment === "credit-card") {
      return paymentMethod;
    }
    if (formik?.values?.activePayment === "ach") {
      return achPaymentMethod;
    }
    return null;
  }, [formik?.values?.activePayment, paymentMethod, achPaymentMethod]);

  const currentPaymentMethod = useMemo(() => getCurrentPaymentMethod(), [
    getCurrentPaymentMethod,
  ]);
  const isStripe = useMemo(() => checkIsStripe(currentPaymentMethod), [
    currentPaymentMethod,
  ]);
  const isTranzila = useMemo(() => checkIsTranzila(currentPaymentMethod), [
    currentPaymentMethod,
  ]);

  const checkDisabledApplyToAllTickets = useCallback(() => {
    const firstTicket = ticketTypeTabs?.[0];
    if (!firstTicket) return true;
    const isFirstTicketValid = firstTicket?.valid;
    return !isFirstTicketValid;
  }, [ticketTypeTabs]);

  const applyInformationHandler = useCallback(() => {
    if (applyToAllTickets) {
      return setApplyToAllTickets(false);
    }
    const updatedFormDataReservation = [...formDataReservation];
    const firstTicketFormData = updatedFormDataReservation[0]?.formData || [];
    if (firstTicketFormData?.length === 0) return;

    const updatedFormData = updatedFormDataReservation.map((item, index) => {
      if (index === 0) return item;
      const updatedFormDataItem = firstTicketFormData.map((field) => {
        const existingField = item?.formData?.find((f) => f.id === field.id);
        return existingField ? { ...existingField, value: field.value } : field;
      });
      return {
        ...item,
        formData: updatedFormDataItem,
      };
    });
    formik.setFieldValue("registrationForm", updatedFormData);
    setApplyToAllTickets(true);
    const updatedTicketTypeTabs = ticketTypeTabs?.map((item, index) => {
      if (index === 0) return item;
      return { ...item, valid: true };
    });
    setTicketTypeTabs(updatedTicketTypeTabs);
  }, [formDataReservation, formik, applyToAllTickets]);

  const dueAmountConvenienceFee = useCallback(
    (totalDueAmount) => {
      if (!currentPaymentMethod) return 0;
      const shouldApplyConvenienceFee =
        currentPaymentMethod.coverConvenienceFee &&
        convenienceFeeByPayment[activePayment];

      if (!shouldApplyConvenienceFee) return 0;
      return calcConvenienceFee(
        currentPaymentMethod?.convenienceFeeInfo,
        totalDueAmount,
      );
    },
    [currentPaymentMethod, convenienceFeeByPayment, activePayment],
  );

  const calculateAmountProducts = (items, type = "ticket") => {
    return items.reduce((total, item) => {
      const installmentValue =
        item?.installmentStatus && item?.installment?.value;
      const itemAmount = item?.totalAmount;
      return (
        total + (installmentValue ? itemAmount / installmentValue : itemAmount)
      );
    }, 0);
  };

  const calculateDueAmount = useCallback(() => {
    const allProducts = getAllProducts();

    const totalAfterDiscount = calculation.calculateBulkClassesAmount(
      selectedClassesList,
      isAuth,
    );
    const dueTotalAfterDiscount = calculation.calculateBulkClassesDueAmount(
      selectedClassesList,
      isAuth,
    );
    const totalProductAmount = calculateAmountProducts(allProducts, "product");
    const totalDueAmount = totalProductAmount + dueTotalAfterDiscount + donationAmount;
    const totalAmount = totalProductAmount + totalAfterDiscount;

    const dueConvenienceFeeAmount = dueAmountConvenienceFee(totalDueAmount);
    const convenienceFeeAmount = dueAmountConvenienceFee(totalDueAmount);

    return {
      totalDueAmount,
      dueAmountCF: convenienceFeeAmount,
      totalDueAmountWithCF: totalDueAmount + dueConvenienceFeeAmount,
      totalAmountWithCF: totalAmount + convenienceFeeAmount,
      // dueAmountTotalDiscount: discountTotal
    };
  }, [
    getAllProducts,
    selectedClassesList,
    dueAmountConvenienceFee,
    isAuth,
    calculation,
    donationAmount,
  ]);

  const handleReserveLogin = () => {
    if (isAuthenticated) {
      handleReserveLogout();
      return;
    }
    localStorage.setItem(
      "redirectUrl",
      `/school/bulk/${params?.id}/registration`,
    );
    window.location.href = "/login";
  };

  const handleReserveLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const {
    totalDueAmount,
    dueAmountCF,
    totalDueAmountWithCF,
    totalAmountWithCF,
  } = calculateDueAmount();

  const reserveLoginButton = useMemo(
    () => (isAuthenticated ? "Logout" : "Member? Log in here"),
    [isAuthenticated],
  );

  return (
    <>
      {formik.values?.resultPage !== "" ? (
        <PaymentResultPage
          result={formik.values?.resultPage}
          formik={formik}
          isTherePayment={totalDueAmount > 0}
        />
      ) : (
        <>
          <Header Logo={logo} />
          <Wrapper>
            <Grid
              container
              spacing={2}
              sx={{ width: isMobile ? "348px" : "100%" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={7} direction="column">
                <ReservationHeader>
                  <Paper
                    sx={{
                      height: isMobile ? "165px" : "227px",
                      borderRadius: "10px",
                      width: "100%",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "#1A2027" : "#2555EF",
                    }}
                  >
                    <ImageContainer isMobile={isMobile}>
                      <CardContent isMobile={isMobile}>
                        <h1>{bulkClassDetails?.bulkName}</h1>
                      </CardContent>
                      <div>
                        <ImageCard
                          src={CardImage}
                          alt="bg"
                          isMobile={isMobile}
                        />
                      </div>
                    </ImageContainer>
                  </Paper>
                  <Button size="md" onClick={handleAddNewClassTicket}>
                    <PlusIcon />
                    <span>Enrollment</span>
                  </Button>
                </ReservationHeader>
                <ReservationTabs
                  tabs={ticketTypeTabs}
                  displayTabLabel={displayTicketName}
                  onTabsChange={(index) => {
                    setActiveTicket(index);
                  }}
                  activeTab={activeTicket}
                  onDeleteTab={onDeleteTicket}
                />
                <Ticket
                  allowAppToAllTickets={
                    activeTicket === 0 && formDataReservation?.length > 1
                  }
                  disabledAppToAllTickets={checkDisabledApplyToAllTickets()}
                  key={`ticket_${applyToAllTickets}_${applySelectedFamilyMember}`}
                  formik={formik}
                  setApplySelectedFamilyMember={setApplySelectedFamilyMember}
                  applyToAllTickets={applyToAllTickets}
                  classes={classesList || []}
                  ticketId={ticketTypeTabs[activeTicket]?.id}
                  openClassInfoModal={openClassInfoModal}
                  setSelectedClass={setSelectedClass}
                  selectedClass={selectedClass}
                  currentFormData={getCurrentFormTaskData() || []}
                  errors={getCurrentFormTicketErrors() || []}
                  updatedFormDataHandler={updatedFormDataHandler}
                  answerFormData={formDataReservation?.[activeTicket]?.formData}
                  productsData={
                    formDataReservation?.[activeTicket]?.products || []
                  }
                  activeTicket={activeTicket}
                  currentClass={getCurrentClass(
                    ticketTypeTabs[activeTicket]?.id,
                  )}
                  familyMembers={familyMembers}
                  isFamilyMemberLoading={isFamilyMemberLoading}
                  hasMoreFamilyMembers={hasMoreFamilyMembers}
                  handleFamilyMemberSearch={handleFamilyMemberSearch}
                  handleFamilyMemberScroll={handleFamilyMemberScroll}
                  isAuth={isAuth}
                  reserveLoginButton={reserveLoginButton}
                  handleReserveLogin={handleReserveLogin}
                  applyInformationHandler={applyInformationHandler}
                  currentFormReservation={formDataReservation?.[activeTicket]}
                  onSelectClass={onSelectClass}
                  removeSelectedClass={removeSelectedClass}
                  removeFamilyMember={removeFamilyMember}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={5} direction="column">
                {(totalDueAmount > 0 || selectedClassesList?.some((c) =>
                  c?.class_pricing?.prices?.some((p) => p.type === "onRegistration" && p.amount > 0)
                )) && (
                  <SummaryCard
                    isInstallmentEnabled={isInstallmentEnabled}
                    onUpdatedClassDetails={onUpdatedClassDetails}
                    setActivePaymentAfter={setActivePaymentAfter}
                    selectedClassesList={selectedClassesList}
                    allProducts={getAllProducts()}
                    updatedProducts={updatedProducts}
                    totalDueAmount={totalDueAmount}
                    dueAmountCF={dueAmountCF}
                    totalDueAmountWithCF={totalDueAmountWithCF}
                    totalPaymentWithCVFee={totalAmountWithCF}
                    isAuth={isAuth}
                    activePayment={activePayment}
                    convenienceFeeByPayment={convenienceFeeByPayment}
                    setConvenienceFeeByPayment={setConvenienceFeeByPayment}
                    currentPaymentMethod={currentPaymentMethod}
                    formDataReservation={formDataReservation}
                    donationAmount={donationAmount}
                    onCalcDueAmountChange={setCalcDueAmount}
                    onCalcPriceStatusChange={setCalcPriceFailed}
                  />
                )}
                <BulkTicket
                  key={`bulk_ticket_${applyAccountDetails}`}
                  currentFormData={bulkClassDetails?.form?.task_data}
                  answerFormData={formik?.values?.bulkRegistrationForm}
                  updateBulkFormDataHandler={updateBulkFormDataHandler}
                  errors={formik?.values?.bulkRegistrationFormErrors}
                />
                {totalDueAmount > 0 && (
                  <>
                    <PersonalDetailsCard
                      formik={formik}
                      setError={setError}
                      isTherePayment={totalDueAmountWithCF > 0}
                      showZipCode={!isAuth}
                      isAuthenticated={isAuth}
                      logout={logout}
                      handleLogout={handleLogout}
                    />
                    <DonationBox
                      ledger={checkoutDonationLedger}
                      loading={isLoadingDonationLedger}
                      onDonationChange={(amount, ledger) => { setDonationAmount(amount); if (ledger) setCheckoutDonationLedger(ledger); }}
                    />
                    <PaymentCard
                      formik={formik}
                      setError={setError}
                      error={error}
                      PayNow={payNow}
                      isLoadingPay={isLoadingPay}
                      setLoadingPay={setLoadingPay}
                      isStripe={isStripe}
                      isTranzila={isTranzila}
                      currentPaymentMethod={currentPaymentMethod}
                      addCardStripeRef={addCardStripeRef}
                      isAuthenticated={isAuth}
                      setSelectedCard={setSelectedCard}
                      selectedCard={selectedCard}
                      setSelectedAchCard={setSelectedAchCard}
                      selectedAchCard={selectedAchCard}
                      recaptchaRef={recaptchaRef}
                      enableCreditCardPay={enableCreditCardPay}
                      enableAchPay={enableAchPay}
                      disabledAchPay={disabledAchPay || calcPriceFailed}
                      displayAchTooltip={displayAchTooltip}
                      disabledCreditCardPay={disabledCreditCardPay || calcPriceFailed}
                      publicKey={
                        currentPaymentMethod?.paymentGateway?.keys?.publicKey
                      }
                      totalDueAmountWithCF={calcDueAmount !== null ? calcDueAmount : totalDueAmountWithCF}
                      calcPriceFailed={calcPriceFailed}
                      onTranzilaCharged={handleTranzilaCharged}
                      orgId={localStorage.getItem("schoolOrgId")}
                    />
                  </>
                )}
              </Grid>
            </Grid>
            <ContactUs />
          </Wrapper>
          {totalDueAmount <= 0 && (
            <Grid item xs={12} className="mt-4">
              <PaymentButtonSubmit isDisabled={isLoadingPay || calcPriceFailed}>
                <button
                  disabled={isLoadingPay || calcPriceFailed}
                  onClick={() => {
                    payNow();
                  }}
                >
                  {isLoadingPay ? (
                    <ClipLoader
                      color={"#ffffff"}
                      loading={isLoadingPay}
                      size={32}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </PaymentButtonSubmit>
            </Grid>
          )}
          <AlertDialog
            open={confirmDeleteTicket.open}
            handleClose={closeConfirmDeleteTicket}
            onDecline={closeConfirmDeleteTicket}
            onAccept={handleDeleteTicket}
            isLoading={confirmDeleteTicket.isLoading}
            content={
              <div className="alert-message-popup">
                <p className="alert-icon">{/* <DeleteForeverIcon /> */}</p>
                <div>
                  <p>Delete Enrollment</p>
                  <p className="alert-message">
                    Are you sure you want to remove this enrollment?
                  </p>
                </div>
              </div>
            }
          />
          <MyModal
            className="add-card-modal"
            open={classInfoModal.open}
            onClose={closeClassInfoModal}
          >
            <ViewClassInfoModal
              classDetails={classInfoModal.classDetails}
              closeModal={closeClassInfoModal}
              onSelectClass={onSelectClass}
            />
          </MyModal>
        </>
      )}
    </>
  );
};

export default ReservationBulkSchoolPage;
